module.exports = __WEBPACK_EXTERNAL_MODULE_805__;


//////////////////
// WEBPACK FOOTER
// external "weaWorkflow"
// module id = 805
// module chunks = 2